import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { FC, PropsWithChildren } from "react";
import AppTheme from "../../styles/theme";

const ComponentWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <MantineProvider
      withCSSVariables
      theme={AppTheme}
    >
      <Notifications position="top-right" />
      <ModalsProvider
        modalProps={{ zIndex: 1201 }}
      >
        {children}
      </ModalsProvider>
    </MantineProvider>
  );
};

export default ComponentWrapper;
